// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Message__message-bc68e3 {
  flex-shrink: 0;
  padding: 2px 0;
  box-sizing: border-box;
  display: flex;
  --start-animation-background: var(--average-background);
  --end-animation-background: transparent;
  position: relative;
  justify-content: center;
  overflow: visible;
  --highlight-in-and-out-animation-duration: 0s;
}

.Message__wrapper-d96807 {
  max-width: 810px;
  margin: 0 auto;
  width: 100%;
  padding: 0 var(--indent-16px);
  display: flex;
  justify-content: center;
}

.Message__message-bc68e3:hover .message-menu {
  opacity: 1;
}

.Message__message-bc68e3:hover .reaction-info {
  opacity: 1;
}

.Message__top-gap-cfc763 {
  margin-top: 14px;
}

.Message__focus-message-d492e8 {
  background-color: var(--end-animation-background);
}

.Message__focus-message-active-e05671 {
  background: var(--start-animation-background);
  transition: background-color var(--highlight-in-and-out-animation-duration) linear;
}

.Message__exit-focus-message-be7e41 {
  background: var(--start-animation-background);
}

.Message__exit-focus-message-active-d6768d {
  background-color: var(--end-animation-background);
  transition: background-color var(--highlight-in-and-out-animation-duration) linear;
}

.Message__payload-wrapper-d4726f {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.Message__view-observer-f0ff93 {
  position: absolute;
  bottom: 0;
  width: 0;
  height: 50%;
}

.Message__pre-view-observer-be8c7a {
  position: absolute;
  top: -200%;
  width: 0;
  height: 500%;
}

.Message__type-system-a90f5c {
  margin-top: 8px;
}

.Message__service-message-e9da1d {
  box-sizing: border-box;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Message.styles.m.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,cAAA;EACA,sBAAA;EACA,aAAA;EACA,uDAAA;EACA,uCAAA;EACA,kBAAA;EACA,uBAAA;EACA,iBAAA;EACA,6CAAA;AACF;;AAEA;EACE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,6BAAA;EACA,aAAA;EACA,uBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,iDAAA;AACF;;AAEA;EACE,6CAAA;EACA,kFAAA;AACF;;AAEA;EACE,6CAAA;AACF;;AAEA;EACE,iDAAA;EACA,kFAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,2BAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAEA;EACE,sBAAA;AACF","sourcesContent":[".message {\n  flex-shrink: 0;\n  padding: 2px 0;\n  box-sizing: border-box;\n  display: flex;\n  --start-animation-background: var(--average-background);\n  --end-animation-background: transparent;\n  position: relative;\n  justify-content: center;\n  overflow: visible;\n  --highlight-in-and-out-animation-duration: 0s;\n}\n\n.wrapper {\n  max-width: 810px;\n  margin: 0 auto;\n  width: 100%;\n  padding: 0 var(--indent-16px);\n  display: flex;\n  justify-content: center;\n}\n\n.message:hover :global(.message-menu) {\n  opacity: 1;\n}\n\n.message:hover :global(.reaction-info) {\n  opacity: 1;\n}\n\n.top-gap {\n  margin-top: 14px;\n}\n\n.focus-message {\n  background-color: var(--end-animation-background);\n}\n\n.focus-message-active {\n  background: var(--start-animation-background);\n  transition: background-color var(--highlight-in-and-out-animation-duration) linear;\n}\n\n.exit-focus-message {\n  background: var(--start-animation-background);\n}\n\n.exit-focus-message-active {\n  background-color: var(--end-animation-background);\n  transition: background-color var(--highlight-in-and-out-animation-duration) linear;\n}\n\n.payload-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n}\n\n.view-observer {\n  position: absolute;\n  bottom: 0;\n  width: 0;\n  height: 50%;\n}\n\n.pre-view-observer {\n  position: absolute;\n  top: -200%;\n  width: 0;\n  height: 500%;\n}\n\n.type-system {\n  margin-top: 8px;\n}\n\n.service-message {\n  box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"message": `Message__message-bc68e3`,
	"wrapper": `Message__wrapper-d96807`,
	"message-menu": `message-menu`,
	"messageMenu": `message-menu`,
	"reaction-info": `reaction-info`,
	"reactionInfo": `reaction-info`,
	"top-gap": `Message__top-gap-cfc763`,
	"topGap": `Message__top-gap-cfc763`,
	"focus-message": `Message__focus-message-d492e8`,
	"focusMessage": `Message__focus-message-d492e8`,
	"focus-message-active": `Message__focus-message-active-e05671`,
	"focusMessageActive": `Message__focus-message-active-e05671`,
	"exit-focus-message": `Message__exit-focus-message-be7e41`,
	"exitFocusMessage": `Message__exit-focus-message-be7e41`,
	"exit-focus-message-active": `Message__exit-focus-message-active-d6768d`,
	"exitFocusMessageActive": `Message__exit-focus-message-active-d6768d`,
	"payload-wrapper": `Message__payload-wrapper-d4726f`,
	"payloadWrapper": `Message__payload-wrapper-d4726f`,
	"view-observer": `Message__view-observer-f0ff93`,
	"viewObserver": `Message__view-observer-f0ff93`,
	"pre-view-observer": `Message__pre-view-observer-be8c7a`,
	"preViewObserver": `Message__pre-view-observer-be8c7a`,
	"type-system": `Message__type-system-a90f5c`,
	"typeSystem": `Message__type-system-a90f5c`,
	"service-message": `Message__service-message-e9da1d`,
	"serviceMessage": `Message__service-message-e9da1d`
};
module.exports = ___CSS_LOADER_EXPORT___;
